import { AssignmentTwoTone } from "@mui/icons-material";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  Grid,
  Grow,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import { useState } from "react";
import React from "react";
import { OrdiniRitiroContext } from "../../../context";
import { useContext } from "react";
import { useEffect } from "react";
import { useForm } from "../../../hooks";
import { CurrencySimbol } from "../../../utilities";

const Contrassegno = ({ setMainForm, mainForm, scrollBott, formAutomatico = {} }) => {
  const [checked, setChecked] = useState(mainForm.sceltaContrassegno);

  //13/08/2026 Greg: quando il ritiro arriva da un Preventivo, il contrassegno è già
  //quello su cui è stata calcolata la tariffa: la sezione resta visibile/compilata
  //ma non editabile dall'utente.
  const compilatoDaformAutomatico = formAutomatico && Object.keys(formAutomatico).length > 0;

  const {
    state: { valuteList, tipiIncassi },
    getTipiIncassi,
    getValute,
  } = useContext(OrdiniRitiroContext);

  useEffect(() => {
    getTipiIncassi();
    getValute();

    if (contrassegnoForm.ImportoCOD !== "") {
      setChecked(true);
    }
  }, []);

  // Nel preventivo il contrassegno è salvato come TipoIncasso/Contrassegno/ContrassegnoValuta
  // (vedi PreventiviFormComponent/Contrassegno.js): quando il ritiro arriva da un preventivo,
  // formAutomatico ha quei nomi di campo e non TipoIncassoCOD/ImportoCOD/ValutaCOD.
  const {
    values: contrassegnoForm,
    changeHandler,
    setValues,
  } = useForm(
    {
      TipoIncassoCOD: formAutomatico.TipoIncassoCOD || formAutomatico.TipoIncasso || " ",
      ImportoCOD: formAutomatico.ImportoCOD || formAutomatico.Contrassegno || "",
      ValutaCOD: formAutomatico.ValutaCOD || formAutomatico.ContrassegnoValuta || "EUR",
    },
    []
  );

  useEffect(() => {
    if (!checked && (formAutomatico.TipoIncassoCOD === undefined || formAutomatico.TipoIncassoCOD === "") && (formAutomatico.TipoIncasso === undefined || formAutomatico.TipoIncasso === "")) {
      setValues({
        ...contrassegnoForm,
        TipoIncassoCOD: " ",
        ImportoCOD: "",
        ValutaCOD: "EUR",
      });
    } else {
      setValues({ ...contrassegnoForm, sceltaContrassegno: checked });
    }

  }, [checked]);

  useEffect(() => {
    //11/08/2026 Greg: updater funzionale (vedi MerceADR/DettaglioMisureMerce) per non
    //perdere questi campi quando più sezioni montano insieme (ordine da Preventivo).
    setMainForm(prev => ({ ...prev,
      TipoIncassoCOD: contrassegnoForm.TipoIncassoCOD,
      ImportoCOD: contrassegnoForm.ImportoCOD,
      ValutaCOD: contrassegnoForm.ValutaCOD,
    }));
  }, [contrassegnoForm]);

  return (
    <Card
      elevation={0}
      sx={{ background: (theme) => theme.palette.info.main + "20" }}
    >
      <CardHeader
        title={"Contrassegno"}
        subheader={""}
        subheaderTypographyProps={{
          fontWeight: "bold",
        }}
        titleTypographyProps={{
          fontWeight: "bold",
          fontSize: 18,
        }}
        avatar={<AssignmentTwoTone />}
        action={
          <FormControlLabel
            control={
              <Switch checked={checked} disabled={compilatoDaformAutomatico} onClick={() => setChecked(!checked)} />
            }
            label=""
          />
        }
      />

      {checked ? (
        <Grow in={checked} timeout={{ appear: 1000, enter: 1000, exit: 1000 }}>
          <CardContent>
            <Grid item container spacing={1}>
              <Grid item xs={12} md={4} lg={4} mt={2}>
                <FormControl fullWidth>
                  <InputLabel id="select-from-nations">Tipo incasso</InputLabel>
                  <Select
                    fullWidth
                    size="small"
                    labelId="select-from-nations"
                    id="select-from-nations"
                    value={contrassegnoForm.TipoIncassoCOD || ""}
                    disabled={compilatoDaformAutomatico}
                    onChange={(e) =>
                      changeHandler("TipoIncassoCOD", e.target.value)
                    }
                    label="Tipo incasso"
                  >
                    <MenuItem value={" "}>Seleziona tipo incasso</MenuItem>
                    {tipiIncassi?.map((params, key) => (
                      <MenuItem key={key} value={params.codice}>
                        {params.codice} - {params.descrizione}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4} mt={2}>
                <FormControl fullWidth>
                  <InputLabel id="select-from-nations">Valuta</InputLabel>
                  <Select
                    fullWidth
                    size="small"
                    labelId="select-from-nations"
                    id="select-from-nations"
                    value={contrassegnoForm.ValutaCOD || ""}
                    disabled={compilatoDaformAutomatico}
                    onChange={(e) => changeHandler("ValutaCOD", e.target.value)}
                    label="Valuta"
                  >
                    <MenuItem value={" "}>Seleziona valuta</MenuItem>
                    {valuteList?.map((params, key) => (
                      <MenuItem key={key} value={params.codice}>
                        {params.codice} - {params.descrizione}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  margin="normal"
                  fullWidth
                  size="small"
                  label="Importo"
                  autoComplete="off"
                  value={contrassegnoForm.ImportoCOD || ""}
                  disabled={compilatoDaformAutomatico}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {CurrencySimbol(contrassegnoForm.ValutaCOD)}
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => changeHandler("ImportoCOD", e.target.value)}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Grow>
      ) : (
        <></>
      )}
    </Card>
  );
};

export default Contrassegno;
